document.addEventListener('DOMContentLoaded', function() {
    var uuid = document.querySelector('.asset-upsells').dataset.uuid;
    if (__tnt.isAuthor && __tnt.client.capabilities.supportsLocalStorage && localStorage.getItem('tnt-upsell-'+uuid+'-shown') === null) {
        $('#asset-upsells-'+uuid).modal('show');
        localStorage.setItem('tnt-upsell-'+uuid+'-shown', 'true');
    }
});